import styles from "../../../../styles/patient-page-modules/readingModal.module.css";
import { formatDate, convertUTCToLocal } from "../../../../utils/helper";

export const temperatureColumns = [
  {
    key: "reading_dates",
    label: "Reading Dates",
    alignLeft: true,
    // SCRUM-989: the rows have no "reading_dates" field, so the sort arrows
    // need the date shown (date and time).
    sortField: "recorded_at",
    render: (reading) => convertUTCToLocal(reading.recorded_at),
  },
  {
    key: "temperature",
    label: "Temperature",
    render: (reading) => (
      <div className={styles.condition}>
        <div
          className={styles.condition_mark}
          style={{
            backgroundColor:
              reading.temperature < 120
                ? "green"
                : reading.temperature < 130
                ? "yellow"
                : "red",
            borderColor:
              reading.temperature < 120
                ? "greenyellow"
                : reading.temperature < 130
                ? "gold"
                : "orange",
          }}
        ></div>{" "}
        {reading.temperature} F
      </div>
    ),
  },
  //   {
  //     key: "diastolic",
  //     label: "Diastolic",
  //     render: (reading) => (
  //       <div className={styles.condition}>
  //         <div
  //           className={styles.condition_mark}
  //           style={{
  //             backgroundColor:
  //               reading.value2 < 80
  //                 ? "green"
  //                 : reading.value2 < 90
  //                 ? "yellow"
  //                 : "red",
  //             borderColor:
  //               reading.value2 < 80
  //                 ? "greenyellow"
  //                 : reading.value2 < 90
  //                 ? "gold"
  //                 : "orange",
  //           }}
  //         ></div>{" "}
  //         {reading.value2} mm Hg
  //       </div>
  //     ),
  //   },
  // {
  //   key: "pulse",
  //   label: "Pulse",
  //   render: (reading) => (
  //     <div className={styles.condition}>
  //       <div
  //         className={styles.condition_mark}
  //         style={{
  //           backgroundColor:
  //             reading.pulse >= 60 && reading.pulse <= 80
  //               ? "green"
  //               : reading.pulse < 60 || reading.pulse > 100
  //               ? "red"
  //               : "yellow",
  //           borderColor:
  //             reading.pulse >= 60 && reading.pulse <= 80
  //               ? "greenyellow"
  //               : reading.pulse < 60 || reading.pulse > 100
  //               ? "orange"
  //               : "gold",
  //         }}
  //       ></div>{" "}
  //       {reading.pulse} bpm
  //     </div>
  //   ),
  // },
];
